var _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningYellowSign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.6749 52.5H6.32491C5.87664 52.5128 5.43324 52.4044 5.04143 52.1862C4.64962 51.968 4.32393 51.6482 4.09869 51.2604C3.87344 50.8727 3.75699 50.4313 3.76161 49.9829C3.76622 49.5344 3.89173 49.0956 4.12491 48.7125L27.8349 7.62501C28.0543 7.24499 28.3699 6.92943 28.75 6.71003C29.13 6.49063 29.5611 6.37512 29.9999 6.37512C30.4387 6.37512 30.8698 6.49063 31.2499 6.71003C31.6299 6.92943 31.9455 7.24499 32.1649 7.62501L55.8749 48.7125C56.1081 49.0956 56.2336 49.5344 56.2382 49.9829C56.2428 50.4313 56.1264 50.8727 55.9011 51.2604C55.6759 51.6482 55.3502 51.968 54.9584 52.1862C54.5666 52.4044 54.1232 52.5128 53.6749 52.5V52.5Z",
    fill: "url(#paint0_linear_1540_9486)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.6749 52.5H6.32491C5.87664 52.5128 5.43324 52.4044 5.04143 52.1862C4.64962 51.968 4.32393 51.6482 4.09869 51.2604C3.87344 50.8727 3.75699 50.4313 3.76161 49.9829C3.76622 49.5344 3.89173 49.0956 4.12491 48.7125L27.8349 7.62501C28.0543 7.24499 28.3699 6.92943 28.75 6.71003C29.13 6.49063 29.5611 6.37512 29.9999 6.37512C30.4387 6.37512 30.8698 6.49063 31.2499 6.71003C31.6299 6.92943 31.9455 7.24499 32.1649 7.62501L55.8749 48.7125C56.1081 49.0956 56.2336 49.5344 56.2382 49.9829C56.2428 50.4313 56.1264 50.8727 55.9011 51.2604C55.6759 51.6482 55.3502 51.968 54.9584 52.1862C54.5666 52.4044 54.1232 52.5128 53.6749 52.5V52.5Z",
    fill: "url(#paint1_linear_1540_9486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6749 52.5H6.32491C5.87664 52.5128 5.43324 52.4044 5.04143 52.1862C4.64962 51.968 4.32393 51.6482 4.09869 51.2604C3.87344 50.8727 3.75699 50.4313 3.76161 49.9829C3.76622 49.5344 3.89173 49.0956 4.12491 48.7125L27.8349 7.62501C28.0543 7.24499 28.3699 6.92943 28.75 6.71003C29.13 6.49063 29.5611 6.37512 29.9999 6.37512C30.4387 6.37512 30.8698 6.49063 31.2499 6.71003C31.6299 6.92943 31.9455 7.24499 32.1649 7.62501L55.8749 48.7125C56.1081 49.0956 56.2336 49.5344 56.2382 49.9829C56.2428 50.4313 56.1264 50.8727 55.9011 51.2604C55.6759 51.6482 55.3502 51.968 54.9584 52.1862C54.5666 52.4044 54.1232 52.5128 53.6749 52.5V52.5Z",
    fill: "url(#paint2_linear_1540_9486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6749 52.5H6.32491C5.87664 52.5128 5.43324 52.4044 5.04143 52.1862C4.64962 51.968 4.32393 51.6482 4.09869 51.2604C3.87344 50.8727 3.75699 50.4313 3.76161 49.9829C3.76622 49.5344 3.89173 49.0956 4.12491 48.7125L27.8349 7.62501C28.0543 7.24499 28.3699 6.92943 28.75 6.71003C29.13 6.49063 29.5611 6.37512 29.9999 6.37512C30.4387 6.37512 30.8698 6.49063 31.2499 6.71003C31.6299 6.92943 31.9455 7.24499 32.1649 7.62501L55.8749 48.7125C56.1081 49.0956 56.2336 49.5344 56.2382 49.9829C56.2428 50.4313 56.1264 50.8727 55.9011 51.2604C55.6759 51.6482 55.3502 51.968 54.9584 52.1862C54.5666 52.4044 54.1232 52.5128 53.6749 52.5V52.5Z",
    fill: "url(#paint3_linear_1540_9486)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 43.75C32.5 44.2445 32.3534 44.7278 32.0787 45.1389C31.804 45.5501 31.4135 45.8705 30.9567 46.0597C30.4999 46.2489 29.9972 46.2984 29.5123 46.202C29.0273 46.1055 28.5819 45.8674 28.2322 45.5178C27.8826 45.1681 27.6445 44.7227 27.548 44.2377C27.4516 43.7528 27.5011 43.2501 27.6903 42.7933C27.8795 42.3365 28.2 41.946 28.6111 41.6713C29.0222 41.3966 29.5055 41.25 30 41.25C30.663 41.25 31.2989 41.5134 31.7678 41.9822C32.2366 42.4511 32.5 43.087 32.5 43.75ZM31.1575 21.25H28.8425C28.6706 21.2496 28.5005 21.2846 28.3427 21.3529C28.185 21.4212 28.043 21.5213 27.9257 21.6469C27.8084 21.7726 27.7182 21.921 27.6609 22.0831C27.6036 22.2452 27.5803 22.4173 27.5925 22.5888L28.6638 37.5888C28.6862 37.9047 28.8278 38.2002 29.0598 38.4158C29.2918 38.6314 29.597 38.7508 29.9138 38.75H30.0863C30.403 38.7508 30.7082 38.6314 30.9402 38.4158C31.1722 38.2002 31.3138 37.9047 31.3363 37.5888L32.4075 22.5888C32.4197 22.4173 32.3964 22.2452 32.3391 22.0831C32.2818 21.921 32.1916 21.7726 32.0743 21.6469C31.957 21.5213 31.815 21.4212 31.6573 21.3529C31.4995 21.2846 31.3294 21.2496 31.1575 21.25V21.25Z",
    fill: "url(#paint4_linear_1540_9486)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1540_9486",
    x1: 29.9999,
    y1: 6.37626,
    x2: 29.9999,
    y2: 52.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#FED57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.372,
    stopColor: "#FCCE6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F9C351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#F4B42B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1AB15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1540_9486",
    x1: 29.9999,
    y1: 6.37626,
    x2: 29.9999,
    y2: 52.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD375",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#FFD374",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FED171",
    stopOpacity: 0.039
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#FCCE6B",
    stopOpacity: 0.092
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#FACA63",
    stopOpacity: 0.167
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#F7C458",
    stopOpacity: 0.265
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#F3BD4A",
    stopOpacity: 0.387
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#EFB53B",
    stopOpacity: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#E9AC28",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#E4A214",
    stopOpacity: 0.884
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E09B07"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1540_9486",
    x1: 4.48116,
    y1: 51.8963,
    x2: 44.3662,
    y2: 27.9313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD375",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#FFD374",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FED171",
    stopOpacity: 0.039
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#FCCE6B",
    stopOpacity: 0.092
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#FACA63",
    stopOpacity: 0.167
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#F7C458",
    stopOpacity: 0.265
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#F3BD4A",
    stopOpacity: 0.387
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#EFB53B",
    stopOpacity: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#E9AC28",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#E4A214",
    stopOpacity: 0.884
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E09B07"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1540_9486",
    x1: 54.6687,
    y1: 53.16,
    x2: 14.9937,
    y2: 27.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD375",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#FFD374",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FED171",
    stopOpacity: 0.039
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#FCCE6B",
    stopOpacity: 0.092
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#FACA63",
    stopOpacity: 0.167
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#F7C458",
    stopOpacity: 0.265
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#F3BD4A",
    stopOpacity: 0.387
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#EFB53B",
    stopOpacity: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#E9AC28",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#E4A214",
    stopOpacity: 0.884
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E09B07"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1540_9486",
    x1: 30,
    y1: 21.25,
    x2: 30,
    y2: 46.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningYellowSign);
export default __webpack_public_path__ + "static/media/warning-yellow-sign.3f406e1f63b97221b0902c7626c22951.svg";
export { ForwardRef as ReactComponent };